export class AccountModel {
    protected id: number;
    protected uuid: string;
    protected company_name: string;
    protected status: number;
    protected user_type: string;
    protected company_address_line1: string;
    protected company_address_line2: string;
    protected company_city: string;
    protected company_province: string;
    protected company_country: string;
    protected company_zip: number;
    protected company_logo: string;
    protected company_banner: string;
    protected company_email: string;
    protected company_phone1: string;
    protected company_phone2: string;
    protected company_contact_person: string;
    protected contact_person_designation: string;
    protected person_email: string;
    protected office_days: string;
    protected total_review_count: number;
    protected total_review_rating: number;
    protected average_review_rating: number;
    protected rating_type_id: number;
    protected enabled_comments: string;
    protected disabled_comments: string;
    protected note: string;
    protected note_by_id: number;
    protected note_date: string;
    protected created_at: string;
    protected updated_at: string;
    protected logo_path: string;
    protected banner_path: string;
    protected address: string;
    protected contact_number: string;

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.uuid = obj.uuid ? obj.uuid : '';
        this.company_name = obj.company_name ? obj.company_name : '';
        this.status = obj.status ? obj.status : 0;
        this.user_type = obj.user_type ? obj.user_type : '';
        this.company_address_line1 = obj.company_address_line1 ? obj.company_address_line1 : '';
        this.company_address_line2 = obj.company_address_line2 ? obj.company_address_line2 : '';
        this.company_city = obj.company_city ? obj.company_city : '';
        this.company_province = obj.company_province ? obj.company_province : '';
        this.company_country = obj.company_country ? obj.company_country : '';
        this.company_zip = obj.company_zip ? obj.company_zip : 0;
        this.company_logo = obj.company_logo ? obj.company_logo : '';
        this.company_banner = obj.company_banner ? obj.company_banner : '';
        this.company_email = obj.company_email ? obj.company_email : '';
        this.company_phone1 = obj.company_phone1 ? obj.company_phone1 : '';
        this.company_phone2 = obj.company_phone2 ? obj.company_phone2 : '';
        this.company_contact_person = obj.company_contact_person ? obj.company_contact_person : '';
        this.contact_person_designation = obj.contact_person_designation ? obj.contact_person_designation : '';
        this.person_email = obj.person_email ? obj.person_email : '';
        this.office_days = obj.office_days ? obj.office_days : '';
        this.total_review_count = obj.total_review_count ? obj.total_review_count : 0;
        this.total_review_rating = obj.total_review_rating ? obj.total_review_rating : 0;
        this.average_review_rating = obj.average_review_rating ? obj.average_review_rating : 0;
        this.rating_type_id = obj.rating_type_id ? obj.rating_type_id : 0;
        this.enabled_comments = obj.enabled_comments ? obj.enabled_comments : '';
        this.disabled_comments = obj.disabled_comments ? obj.disabled_comments : '';
        this.note = obj.note ? obj.note : '';

        this.note_by_id = obj.note_by_id ? obj.note_by_id : 0;
        this.note_date = obj.note_date ? obj.note_date : '';
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
        this.logo_path = obj.logo_path ? obj.logo_path : '';
        this.banner_path = obj.banner_path ? obj.banner_path : '';
        this.address = obj.address ? obj.address : '';
        this.contact_number = obj.contact_number ? obj.contact_number : '';
    }
}
